export enum HideAccountCoupons {
  NONE = 'None',
  ORDER_TREE = 'Order Tree',
  CHECKOUT = 'Checkout',
  BOTH = 'Both',
}
